// Create the base App object, used to namespace the elements below.
import "./app/_base"

// Components
import "./app/components/teded_dropdown.js"
import "./app/components/teded_filter.js"
import "./app/components/teded_lessons_grid.js"
import "./app/components/temp_user_timer.js"
import "./app/components/video_colorswatch.js"
import "./app/components/video_animation_controls.js"
import "./app/components/video_lazyload.js"
import "./app/components/youtube_video_seek_to.js"

// header
import "./app/header/notifications.js"

// Pages
import "./app/pages/users/additional_information.js"
import "./app/pages/videos.js"

// plugins have been moved to javascripts/packs/application.js

import "./app/shared/script.js"

import "./app/search/search-results.js"
import "./app/ga_tracking.js"
import "./app/yt_player_with_ga_tracking.js"
